import {useTranslation} from 'react-i18next';
import {translations} from '../../i18n/translations';
import {Stack, SxProps, Theme, Tooltip} from '@mui/material';
import {KeyboardArrowDownRounded, KeyboardArrowUpRounded} from '@mui/icons-material';

interface SortIconProps {
  active: boolean;
  direction?: 'asc' | 'desc';
}

export const SortIcon = ({active, direction}: SortIconProps) => {
  const {t} = useTranslation();

  const wrapper: SxProps<Theme> = {
    marginLeft: '10px',
  };

  const iconStyles: SxProps<Theme> = {
    height: '10px',
    width: '10px',
  };

  const activeSx: SxProps<Theme> = {
    opacity: 1,
  };

  const inactiveSx: SxProps<Theme> = {
    opacity: 0.5,
  };

  return (
    <Tooltip
      title={
        active && direction
          ? direction === 'asc'
            ? t(translations.care_and_activities.sort_icon.sort_in_descending)
            : t(translations.care_and_activities.sort_icon.sort_in_ascending)
          : undefined
      }
    >
      <Stack sx={wrapper}>
        <KeyboardArrowUpRounded
          sx={{
            ...iconStyles,
            ...(active ? (direction === 'asc' ? activeSx : inactiveSx) : undefined),
            ...(!active && inactiveSx),
          }}
        />
        <KeyboardArrowDownRounded
          sx={{
            ...iconStyles,
            ...(active ? (direction === 'desc' ? activeSx : inactiveSx) : undefined),
            ...(!active && inactiveSx),
          }}
        />
      </Stack>
    </Tooltip>
  );
};
